import { useNavigate, useParams } from "react-router-dom";
import CustomForm from '../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../Util/Form/CustomForm/CustomFormContainer';
import Fetch from '../../../util/core/Fetch';
import config from '../../../../application/config/config';
import { useEffect, useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { getUserSession } from "../../../util/core/Session";
import LastAccess from "../LastAccess/List"
import TreeView from "../ApplicationsProfiles/PermissionTreeview";
import { CheckIfIsViewScreen } from "../../../util/core/CheckIfIsViewScreen";
import { useKeysStore } from "../../../store/useKeysStore";

function Form() {
  const { keys } = useKeysStore();
  const { id } = useParams();
  const dispatch = useDispatch();
  const formSession = useSelector(state => state.core.session);
  const session = getUserSession();
  const [form, setForm] = useState();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('');
  const [permission, setPermission] = useState([]);
  const [formContent, setFormContent] = useState(<>Carregando...</>);
  const [allPermissions, setAllPermissions] = useState([]);

  const isView = CheckIfIsViewScreen();

  const endpointBackend = config.endpoints.backend;
  const path = '/core/users/';
  const paths = {
    endpointSave: endpointBackend + 'core/users/save',
    endpointPermissionSave: endpointBackend + 'core/users/updatepermissions',
    endpointGetById: endpointBackend + 'core/users/getById',
    endpointGetAppProfileById: `${endpointBackend}core/applicationsprofiles/getById`,
    urlGoBack: path + 'list',
    pathView: path + 'view'
  }

  function addPropertiesRecursive(array) {
    return array.map((item) => {
      const newItem = { ...item };
      newItem.canView = true;
      newItem.canAdd = true;
      newItem.canEdit = true;
      newItem.canDelete = true;

      if (newItem.children && newItem.children.length > 0) {
        newItem.children = addPropertiesRecursive(newItem.children);
      }

      return newItem;
    });
  }

  useEffect(() => {
    dispatch({
      type: "UPDATE_SESSION",
      key: "current_user_permission",
      value: permission,
    });
  }, [permission]);

  const hiddenValuesToForm =
    session.user.application_instance_id == keys?.configCore?.admin_application_instance_id ?
      {} :
      {
        application_instance_id: session.user.application_instance_id
      }

  const handleSubmit = async (fields, values, loadData) => {
    const finalPermission = formSession["current_user_permission"];
    const finalValues = { ...values, permissions: finalPermission };
    await Fetch.put(paths.endpointSave, finalValues);
    navigate(paths.urlGoBack);
  };

  const handleChangeTreeView = async (permissions) => {
    const finalValues = { id: id, permissions: permissions };
    setPermission(permissions);
    await Fetch.put(paths.endpointPermissionSave, finalValues);
  };

  const getForm = (values) => {

    const labels = {
      labelTitleAdd: "Novo Usuário",
      labelTitleEdit: "Editar Usuário",
      labelTitleView: 'Visualizar Usuário',
    }

    const form = {
      validateOnChange: true,
      hiddenValues: hiddenValuesToForm,
      handleSubmit,
      fields: [
        {
          name: 'photo',
          type: 'file',
          label: 'Foto',
          uploadPath: '/users/photos/',
          extensionAccept: '.jpeg,.jpg,.png',
          limitFileSize: 5,
          validations: {
          },
          columnSize: 6
        },
        !hiddenValuesToForm.application_instance_id ? {
          name: 'application_instance_id',
          type: 'select',
          label: 'Instalação',
          options: [],
          optionsEndpoint: {
            endpoint: endpointBackend + 'core/applicationsinstances/getall',
            label: 'instance_name',
            value: 'id'
          },
          validations: {
            required: true
          },
          columnSize: 12
        } : {},
        {
          name: 'application_profile_id',
          type: 'select',
          label: 'Perfil',
          handleChange: async (values, fields) => {
            const { target } = values;
            const { permissions } = await Fetch.post(paths.endpointGetAppProfileById, { id: target.value });
            setPermission(permissions);
          },
          options: [],
          optionsEndpoint: {
            endpoint: endpointBackend + 'core/applicationsprofiles/getallselectuser',
            label: 'profile_name',
            value: 'id',
            params: {
              filter: {
                core_application_instance_id: session.user.application_instance_id,
              }
            }
          },
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          type: 'label',
          label: '',
          columnSize: 12
        },
        {
          name: 'name',
          type: 'text',
          label: 'Nome',
          validations: {
            required: true
          },
          columnSize: 12
        },
        {
          name: 'email',
          type: 'email',
          label: 'Email',
          validations: {
            required: true,
            validateEmail: true
          },
          columnSize: 6
        },
        {
          name: 'mobile_phone',
          type: 'phone',
          label: 'Celular',
          validations: {
            required: true
          },
          columnSize: 6
        },
        {
          type: 'label',
          label: '',
          columnSize: 12
        },
        {
          name: 'login',
          type: 'text',
          label: 'Login',
          validations: {
            required: true,
            login: true
          },
          columnSize: 12
        },
        {
          name: 'password',
          type: 'password',
          label: 'Senha',
          validations: {
            password: true
          },
          columnSize: 12
        },
        {
          name: 'password_confirm',
          type: 'password',
          label: 'Repetir senha',
          validations: {
            password_confirm: true
          },
          columnSize: 12
        },
        {
          name: 'status',
          type: 'select',
          label: 'Status',
          options: [
            { label: 'Ativo', value: '1' },
            { label: 'Bloqueado', value: '0' },
          ],
          validations: {
            required: true
          },
          columnSize: 12
        },
      ],
      customValidators: {
        password_confirm: (value, options, key, attributes) => {
          if (attributes.password) {
            if (attributes.password != attributes.password_confirm) {

              return '^O campo repetir senha deve ter igual ao campo senha';
            }
          }
          return '';
        },
        login: async (value, options, key, attributes) => {
          const checkLogin = async (value) => {
            let post = { login: value };
            post.user_id = id;
            if (value.trim().length > 2) {
              let response = await Fetch.post(config.endpoints.backend + 'core/users/getbylogin', post);
              if (response.id) {
                return '^O login já está sendo utilizado por outro usuário';
              }
            }

            return "";
          }
          return checkLogin(value);
        },
        validateEmail: async (value) => {
          const checkEmail = async (value) => {
            let response = await Fetch.post(config.endpoints.backend + 'core/users/getByEmail', { email: value, id: id });

            if (response.id) {
              return '^O e-mail já está sendo utilizado por outro usuário';
            }
            return "";
          }
          return checkEmail(value);
        }
      },
      ...paths,
      ...labels
    }
    return form;
  }

  useEffect(() => {
    const form = getForm({});
    setForm(form);
    setFormContent(
      <div>
        <CustomFormContainer
          form={form}
          content={<CustomForm form={form} />}
        />
      </div>
    );
    setActiveTab("form");
  }, [])

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "form" })}
            onClick={() => {
              setActiveTab("form");
            }}
          >
            Dados do Perfil
          </NavLink>
        </NavItem>
        {id && (
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: activeTab === "list" })}
              onClick={() => {
                setActiveTab("list");
              }}
            >
              Permissionamento
            </NavLink>
          </NavItem>
        )}
        {id && <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === "lastAccess" })}
            onClick={() => {
              setActiveTab("lastAccess");
            }}
          >
            Últimos Acessos
          </NavLink>
        </NavItem>}
      </Nav>
      <TabContent activeTab={activeTab} className="bg-white">
        <TabPane tabId="form">
          <Col sm="12">
            {formContent && formContent}
          </Col>
        </TabPane>
        {id && <TabPane tabId="lastAccess">
          <Col sm="12">
            <LastAccess id={id} />
          </Col>
        </TabPane>}
        {id && (
          <TabPane tabId="list">
            <Col sm="12">
              <TreeView
                disabled={isView}
                endpointGetById={paths.endpointGetById}
                fromUser={true}
                addPropertiesRecursive={addPropertiesRecursive}
                permission={permission}
                setPermission={setPermission}
                allPermissions={allPermissions}
                setAllPermissions={setAllPermissions}
                handleChange={handleChangeTreeView}
                activeTab={activeTab}
              />
            </Col>
          </TabPane>
        )}
      </TabContent>
    </div>
  );
}
export default Form;
